// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sidebar-menu-icon[data-v-03b7c4b9]{width:32px;height:32px;margin-right:8px;vertical-align:middle}", ""]);
// Exports
module.exports = exports;
